// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c7b5d516","239":"5359592c","453":"c99e3a57","732":"cdb8b46c"}[chunkId] + ".chunk.js";
};